export enum CardioConstants {
  NOT_IMPLEMENTED = 'cardio/NOT_IMPLEMENTED',
  SET_CVTEMP = 'cardio/SET_CVTEMP',
  SET_CVTEMPDEGREES = 'cardio/SET_CVTEMPDEGREES',
  SET_CVTEMPMETHOD = 'cardio/SET_CVTEMPMETHOD',
  SET_CVJVD = 'cardio/SET_CVJVD',
  SET_CVCAPREFILL = 'cardio/SET_CVCAPREFILL',
  SET_CVEDEMA = 'cardio/SET_CVEDEMA',
  SET_CVCOMMENTS = 'cardio/SET_CVCOMMENTS',
  SET_CVART = 'cardio/SET_CVART',
  SET_CVSWAN = 'cardio/SET_CVSWAN',
  SET_PRCVASSESS = 'cardio/SET_PRCVASSESS',
  SET_TYPE = 'cardio/SET_TYPE',
  SET_RATE = 'cardio/SET_RATE',
  SET_MA = 'cardio/SET_MA',
  SET_PMMODE = 'cardio/SET_PMMODE',
  SET_RESPONSE = 'cardio/SET_RESPONSE',
  SAVE_INITIAL_ASSESSMENT_CARDIO = 'cardio/SAVE_INITIAL_ASSESSMENT_CARDIO',
  SAVE_INITIAL_ASSESSMENT_CARDIO_NABC = 'cardio/SAVE_INITIAL_ASSESSMENT_CARDIO_NABC',
  SAVE_INITIAL_ASSESSMENT_CARDIO_PRPM = 'cardio/SAVE_INITIAL_ASSESSMENT_CARDIO_PRPM',
  RESET_CARDIO_STATE = 'cardio/RESET_CARDIO_STATE',
  RESET_PACEMAKER = 'cardio/RESET_PACEMAKER',
  RESET_INVASIVE_MONITORING = 'cardio/RESET_INVASIVE_MONITORING',
}
